<script>
import {Form} from '../../helpers/Form/Form'
import VoucherPartecipantModuleForm from './VoucherPartecipantModuleForm'

export default {
    props: {
        mainForm: Object,
        purchaseElement: Object,
        modules: {
            type: Array,
            default() {
                return []
            }
        },
        commonFields: {
            type: Array,
            default() {
                return []
            }
        },
        partecipants: {
            type: Array,
            default() {
                return []
            }
        },
        partecipant: {
            type: Object,
            default() {
                return {}
            }
        },
        partecipantIdx: Number
    },
    components: {
        VoucherPartecipantModuleForm
    },
    data() {
        return {
            form: new Form({
                phone: null
            }),
            sent: false,
            delayFinished: false,
            counter: 60,
            intervalId: null,
            radioValues: {},
            isDisabled: true,
            isSubmitting: false
        }
    },
    computed: {
        allSkipped() {
            let totalModules = 0
            let totalSkipped = 0
            let skipped = this.mainForm.partecipants.forEach(p => {
                totalSkipped += p.modules.filter(i => i.skip).length
                totalModules += p.modules.length
            })
            return totalSkipped == totalModules
        },
        formattedCounter() {
            return (this.counter < 10 ? '0' : '') + this.counter;
        }
    },
    mounted() {
        this.$bus.$on('otp-sent', (payload) => {
            this.$set(this, 'sent', true)
            this.startCounter()
        })

        const sent = this.purchaseElement.otps.length > 0 || this.form.phone !== null

        if (sent) {
            this.$set(this.form, 'phone', this.purchaseElement.otps[0].otp_phone)
            this.$set(this, 'delayFinished', true);
            this.$set(this, 'sent', sent)
        }
    },
    methods: {
        handleRadioValuesUpdate(updatedValues) {
            Object.assign(this.radioValues, updatedValues);
            this.disableButton();
        },
        disableButton() {
            this.isDisabled = true;
            for (let key in this.radioValues) {
                if (this.radioValues[key] !== 1) {
                    return;
                }
            }
            if (Object.keys(this.radioValues).length === 0) {
                return;
            }
            this.isDisabled = false;
        },
        startCounter() {
            this.$set(this, 'delayFinished', false);
            this.$set(this, 'intervalId', setInterval(() => {
                this.onCounterCalled();
            }, 1000));
        },
        onCounterCalled() {
            if (this.counter > 0) {
                this.$set(this, 'counter', this.counter - 1);
            } else {
                this.stopCounter();
            }
        },
        stopCounter() {
            clearInterval(this.intervalId);
            this.$set(this, 'intervalId', null);
            this.$set(this, 'delayFinished', true);
            this.$set(this, 'counter', 60)
        },
        onValidateModule() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            this.mainForm
                .submit('post', route('partecipants.validate_modules', this.purchaseElement.id))
                .then(response => {
                    if (this.partecipantIdx < 0) {
                        this.$bus.$emit('submit-subscription')
                    } else {

                        this.$bus.$emit('modules.validated', {
                            idx: this.partecipantIdx
                        })
                    }
                }).catch(error => {
                this.scrollOnTop()
                this.isSubmitting = false;
            })
        },
        submit() {
            this.$bus.$emit('submit-subscription')
        },
        requestOtp() {
            let data = this.form.data()
            const phone = data.phone

            this.form
                .submit('post', route('module.otp', this.purchaseElement.id))
                .then(response => {
                    window.alerts.success('Codice di conferma inviato via SMS');

                    this.$set(this.form, 'phone', phone)
                    this.$bus.$emit('otp-sent', data)
                })
        },
        onRequestOtp() {
            this.$bus.$emit('opt-signature.show', {
                purchaseElement: this.purchaseElement
            })
        },
        resetSub() {
            let idx = this.partecipantIdx - 1
            if (idx < 0) {
                idx = 0
            }

            this.$bus.$emit('reset-sub-view', {idx})
        },
        nextTo(view) {
            this.$bus.$emit('next-to', view)
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/purchases/VoucherPartecipantModulesContainer.vue